// Sample data for the demo. Replace with API calls (see src/api/clinicApi.js).
// IC numbers below are made up. The UI never shows the last 4 digits (see formatIC in utils/format.js).

export const TODAY = "2026-10-05";

export const CLINIC = {
  name: "Sample Dental Clinic",
  logoUrl: "/clinic-logo.png", // set per clinic; null shows a tooth mark
  phone: "+60",
  email: "[Clinic email]",
  address: "[Clinic address]",
  openTime: "09:00",
  closeTime: "18:00",
  slotMinutes: 30,
  openDays: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
};

export const dentists = [
  {
    id: "d1",
    name: "Dr. Lim Wei Jie",
    initials: "LW",
    role: "General dentist",
    phone: "+60 12-345 6781",
    days: ["Mon", "Tue", "Wed", "Thu", "Fri"],
    focus: ["Fillings", "Root canal", "Crowns"],
    color: "#047fbb",
    qualifications: "BDS (Malaya)",
    experienceYears: 12,
    languages: ["English", "Malay", "Mandarin"],
    fee: 50,
    breakStart: "13:00",
    breakEnd: "14:00",
  },
  {
    id: "d2",
    name: "Dr. Nurul Huda",
    initials: "NH",
    role: "Orthodontist",
    phone: "+60 12-345 6782",
    days: ["Mon", "Wed", "Thu", "Sat"],
    focus: ["Braces", "Clear aligners"],
    color: "#7a4fb5",
    qualifications: "BDS (UKM), MClinDent Ortho",
    experienceYears: 9,
    languages: ["English", "Malay"],
    fee: 80,
    leave: [{ id: "l1", from: "2026-10-15", to: "2026-10-17", type: "Annual leave", note: "" }],
  },
  {
    id: "d3",
    name: "Dr. Daniel Ting",
    initials: "DT",
    role: "Oral surgeon",
    phone: "+60 12-345 6783",
    days: ["Mon", "Tue", "Thu", "Fri", "Sat"],
    focus: ["Extractions", "Wisdom teeth", "Implants"],
    color: "#b5532a",
    qualifications: "BDS (USM), MOSurg",
    experienceYears: 15,
    languages: ["English", "Mandarin"],
    fee: 120,
  },
];

export const treatments = [
  { id: "t1", name: "Consultation & check-up", category: "General", duration: 30, price: 50 },
  { id: "t2", name: "Scaling & polishing", category: "Preventive", duration: 45, price: 120 },
  { id: "t3", name: "Dental X-ray (OPG)", category: "Diagnostic", duration: 15, price: 80 },
  { id: "t4", name: "Composite filling", category: "Restorative", duration: 45, price: 150 },
  { id: "t5", name: "Tooth extraction", category: "Surgical", duration: 30, price: 150 },
  { id: "t6", name: "Wisdom tooth surgery", category: "Surgical", duration: 60, price: 800 },
  { id: "t7", name: "Root canal treatment", category: "Endodontic", duration: 90, price: 900 },
  { id: "t8", name: "Porcelain crown", category: "Restorative", duration: 60, price: 1500 },
  { id: "t9", name: "Teeth whitening", category: "Cosmetic", duration: 90, price: 900 },
  { id: "t10", name: "Braces adjustment", category: "Orthodontic", duration: 30, price: 200 },
  { id: "t11", name: "Children's check-up", category: "General", duration: 30, price: 40 },
];

export const patients = [
  {
    id: "p1", name: "Aisyah Rahman", phone: "+60 12-882 1034", ic: "900514-13-5218", gender: "Female", dob: "1990-05-14",
    email: "aisyah.r@example.com", lastVisit: "2026-09-14", alerts: ["Penicillin allergy"], registered: "2023-02-11",
  },
  {
    id: "p2", name: "Tan Kok Leong", phone: "+60 16-221 7781", ic: "781102-13-6031", gender: "Male", dob: "1978-11-02",
    email: "kl.tan@example.com", lastVisit: "2026-08-30", alerts: ["Diabetes", "On blood thinners"], registered: "2021-07-19",
  },
  {
    id: "p3", name: "Priya Devi", phone: "+60 17-554 0912", ic: "950308-14-5122", gender: "Female", dob: "1995-03-08",
    email: "priya.d@example.com", lastVisit: "2026-07-21", alerts: [], registered: "2024-01-05",
  },
  {
    id: "p4", name: "Jason Wong", phone: "+60 13-778 2290", ic: "120921-13-0457", gender: "Male", dob: "2012-09-21",
    email: "wong.family@example.com", lastVisit: "2026-09-02", alerts: [], registered: "2022-10-10",
  },
  {
    id: "p5", name: "Siti Mariam", phone: "+60 19-330 4471", ic: "690717-13-5544", gender: "Female", dob: "1969-07-17",
    email: "siti.m@example.com", lastVisit: "2026-06-11", alerts: ["Hypertension"], registered: "2020-03-28",
  },
  {
    id: "p6", name: "Ahmad Faizal", phone: "+60 11-2345 8812", ic: "870228-13-5031", gender: "Male", dob: "1987-02-28",
    email: "faizal.a@example.com", lastVisit: "2026-09-25", alerts: [], registered: "2025-04-14",
  },
  {
    id: "p7", name: "Melissa Jau", phone: "+60 14-889 0023", ic: "930611-13-6298", gender: "Female", dob: "1993-06-11",
    email: "melissa.j@example.com", lastVisit: "2026-05-30", alerts: ["Pregnant"], registered: "2023-08-09",
  },
  {
    id: "p8", name: "Ravi Kumar", phone: "+60 12-667 4402", ic: "820419-08-5371", gender: "Male", dob: "1982-04-19",
    email: "ravi.k@example.com", lastVisit: "2026-09-18", alerts: ["Latex allergy"], registered: "2022-01-17",
  },
  {
    id: "p9", name: "Chong Mei Ling", phone: "+60 16-903 1185", ic: "000125-13-0216", gender: "Female", dob: "2000-01-25",
    email: "meiling.c@example.com", lastVisit: "2026-09-29", alerts: [], registered: "2024-06-30",
  },
  {
    id: "p10", name: "Benedict Anak Jimbun", phone: "+60 13-812 5560", ic: "910903-13-5679", gender: "Male", dob: "1991-09-03",
    email: "benedict.j@example.com", lastVisit: "2026-04-12", alerts: [], registered: "2025-11-02",
  },
];

// treatments: one treatment id, or an array of ids when several are done in one visit.
const a = (id, patientId, dentistId, date, start, treatments, status, notes = "") => ({
  id, patientId, dentistId, date, start, treatmentIds: [].concat(treatments), status, notes,
});

export const appointments = [
  // Mon 5 Oct (today)
  a("a1", "p1", "d1", "2026-10-05", "09:00", "t4", "completed", "Filling on 26"),
  a("a2", "p2", "d1", "2026-10-05", "10:00", "t7", "in-treatment", "RCT visit 2 of 3 on 37"),
  a("a3", "p8", "d1", "2026-10-05", "14:00", ["t2", "t3"], "confirmed"),
  a("a4", "p9", "d1", "2026-10-05", "15:30", "t1", "scheduled"),
  a("a5", "p4", "d2", "2026-10-05", "09:30", "t10", "checked-in", "Parent: Mrs Wong"),
  a("a6", "p3", "d2", "2026-10-05", "11:00", "t10", "confirmed"),
  a("a7", "p7", "d2", "2026-10-05", "16:00", "t1", "scheduled", "Second trimester — no X-ray"),
  { ...a("a8", "p6", "d3", "2026-10-05", "09:00", "t6", "completed", "Lower left 38"), checkedOut: "INV-2026-0147" },
  a("a9", "p10", "d3", "2026-10-05", "11:30", "t5", "no-show"),
  a("a10", "p5", "d3", "2026-10-05", "14:30", "t3", "confirmed"),
  a("a11", "p1", "d3", "2026-10-05", "16:30", "t5", "cancelled", "Patient rescheduled"),
  // Tue 6 Oct
  a("a12", "p5", "d1", "2026-10-06", "09:30", "t8", "confirmed"),
  a("a13", "p6", "d1", "2026-10-06", "13:00", ["t1", "t3"], "scheduled"),
  a("a14", "p8", "d3", "2026-10-06", "10:00", "t5", "scheduled"),
  // Wed 7 Oct
  a("a15", "p3", "d1", "2026-10-07", "10:00", "t9", "scheduled"),
  a("a16", "p4", "d2", "2026-10-07", "15:00", "t11", "confirmed"),
  // Thu 8 Oct
  a("a17", "p9", "d2", "2026-10-08", "11:00", "t10", "scheduled"),
  a("a18", "p10", "d3", "2026-10-08", "14:00", "t6", "scheduled"),
  // Past
  a("a19", "p1", "d1", "2026-09-14", "11:00", "t2", "completed"),
  a("a20", "p2", "d1", "2026-08-30", "10:00", "t7", "completed", "RCT visit 1 of 3"),
  a("a21", "p8", "d3", "2026-09-18", "15:00", "t3", "completed"),
];

const inv = (id, patientId, date, dueDate, items, paid, method = "") => ({
  id, patientId, date, dueDate, items, paid, method,
});

export const invoices = [
  {
    ...inv("INV-2026-0147", "p6", "2026-10-05", "2026-10-05", [{ treatmentId: "t6", qty: 1 }, { treatmentId: "t3", qty: 1 }], 880, "Card"),
    payments: [{ method: "Card", amount: 880, ref: "4417" }],
  },
  inv("INV-2026-0146", "p9", "2026-09-29", "2026-10-13", [{ treatmentId: "t2", qty: 1 }], 120, "DuitNow QR"),
  inv("INV-2026-0145", "p6", "2026-09-25", "2026-10-09", [{ treatmentId: "t1", qty: 1 }, { treatmentId: "t3", qty: 1 }], 0),
  inv("INV-2026-0144", "p8", "2026-09-18", "2026-10-02", [{ treatmentId: "t3", qty: 1 }, { treatmentId: "t1", qty: 1 }], 0),
  inv("INV-2026-0143", "p1", "2026-09-14", "2026-09-28", [{ treatmentId: "t2", qty: 1 }], 120, "Cash"),
  inv("INV-2026-0142", "p4", "2026-09-02", "2026-09-16", [{ treatmentId: "t11", qty: 1 }], 40, "Cash"),
  inv("INV-2026-0141", "p2", "2026-08-30", "2026-09-13", [{ treatmentId: "t7", qty: 1 }], 500, "Card"),
];

export const products = [
  { id: "r1", name: "Soft toothbrush", price: 12, stock: 46 },
  { id: "r2", name: "Sensitive toothpaste", price: 18, stock: 30 },
  { id: "r3", name: "Antibacterial mouthwash", price: 25, stock: 18 },
  { id: "r4", name: "Dental floss", price: 10, stock: 52 },
  { id: "r5", name: "Interdental brushes (pack)", price: 22, stock: 14 },
  { id: "r6", name: "Retainer case", price: 15, stock: 9 },
  { id: "r7", name: "Paracetamol 500mg (10s)", price: 6, stock: 80 },
  { id: "r8", name: "Chlorhexidine gel", price: 28, stock: 6 },
];

export const PAYMENT_METHODS = ["Cash", "Card", "DuitNow QR", "Bank transfer"];

export const PANELS = ["[Corporate panel A]", "[Corporate panel B]", "[Insurance TPA]"];

export const TOOTH_CONDITIONS = [
  { id: "healthy", label: "Healthy" },
  { id: "caries", label: "Caries" },
  { id: "filled", label: "Filled" },
  { id: "crown", label: "Crown" },
  { id: "root-canal", label: "Root canal" },
  { id: "missing", label: "Missing" },
];

export const APPOINTMENT_STATUS = {
  scheduled: { label: "Scheduled", tone: "neutral" },
  confirmed: { label: "Confirmed", tone: "info" },
  "checked-in": { label: "Checked in", tone: "warning" },
  "in-treatment": { label: "In treatment", tone: "primary" },
  completed: { label: "Completed", tone: "success" },
  cancelled: { label: "Cancelled", tone: "danger" },
  "no-show": { label: "No-show", tone: "danger" },
};
